import { render, staticRenderFns } from "./UserTabPaymentDetailsEdit.vue?vue&type=template&id=21c6d71d"
import script from "./UserTabPaymentDetailsEdit.vue?vue&type=script&lang=js"
export * from "./UserTabPaymentDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports